<template lang="pug">
v-app
  div.app__content(v-if="$routeType($route) == $normalRoute()")
    app-error-modal
    v-content
      .banner
        app-header(v-bind="{ title }")
        router-view(style="margin-top: 56px;")
  div.app__content(v-if="$routeType($route) == $authRoute()")
    v-content
      router-view
  //- TODO modify shipment component to accept prop to conditionate padding classes to save space
  div.app__content(v-if="$routeType($route) == $embeddableRoute()", v-bind:class="{ 'top-margin': $route.name.endsWith('add'), 'remove-margin': $route.name.endsWith('index')}")
    router-view
</template>
<style>
.remove-margin {
  margin: -2rem -3rem;
}
.top-margin {
  margin-top: 2vh;
}
</style>
<script>
import Scrollbar from 'overlayscrollbars'
import AppHeader from '@/components/Header.vue'
import AppErrorModal from '@/components/ErrorModal.vue'
// import * as helpers from './helpers'

export default {
  name: 'app',
  components: {
    AppHeader,
    AppErrorModal,
  },
  data: () => ({
    typeToTitleDictionary: ['Add', 'Edit'],
  }),
  methods: {
    getTranslation(type, entity) {
      if (type === 'Add') {
        return this.$t('Common.createEntity', { entity: entity.toLowerCase() });
      } else {
        return this.$t('Common.editEntity', { entity: entity.toLowerCase() });
      }
    },
  },
  computed: {
    titleFromMeta() {
      return _.get(this.$route, 'meta.title');
    },
    translatedMeta() {
      if (!this.titleFromMeta) return null;
      return this.$tCheck(`titles.${this.titleFromMeta}`, this.titleFromMeta);
    },
    nameToArray() {
      return _.chain(this.$route).get('name').split('.').value();
    },
    entityFromName() {
      return _.chain(this.nameToArray).head().upperFirst().words().join('').value();
    },
    typeFromName() {
      return _.chain(this.nameToArray).last().upperFirst().value();
    },
    entityFromParams() {
      let entityFP = this.$route.params.entity
      return entityFP ? _.chain(entityFP).upperFirst().words().join('').value() : null;
    },
    entity() {
      return this.entityFromParams || this.entityFromName;
    },
    translatedEntity() {
      return this.$tCheckC(`${this.entity}._name`, this.entity, 1);
    },
    titleFromName() {
      return _.includes(this.typeToTitleDictionary, this.typeFromName) ? this.getTranslation(this.typeFromName, this.translatedEntity) : this.translatedEntity;
    },
    title () {
      return this.translatedMeta || this.titleFromName;
    },
  },
}
</script>
